import { landingQuery } from '@/query-factory/landing'
import { searchQuery } from '@/query-factory/search'
import { categoryQuery } from './category'
import { notificationQuery } from './notification'

export const queryFactory = {
  landing: landingQuery,
  search: searchQuery,
  category: categoryQuery,
  notification: notificationQuery,
}
